module.exports = __webpack_public_path__ + "img/34_4.c2340179.png";